const KEY = "GA_LOCAL_IGNORED"

function storeIgnoredLocally(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list))
  } catch (e) {
    // ignore write errors
  }
}

function loadLocalIgnored() {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}

export const localIgnored = {
  store: storeIgnoredLocally,
  load: loadLocalIgnored,
}

